import { ACCOUNT } from './../../model/account.mode';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OUTTYPE } from 'app/model/out-type';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { rules } from '../../model/lengthrule';
import { patternValidator } from 'app/tooltip/validator';
import { Observable } from 'rxjs/Rx';
import {
  orgTypeToValue,
  tenancyTypeToValue,
  creditTypeTypeToValue
} from 'app/model/businessgroup.model';

@Injectable()
export class RetrieveService {
  private RULES = rules;
  constructor(private http: HttpClient, private fb: FormBuilder) {}

  fillForm(accountcode?: string): Observable<OUTTYPE> {
     let newurl = 'api/getform/';
     //let newurl = 'https://localhost:44340/api/values/';
     //let newurl = 'api/values/';
     //debugger;
    let account: ACCOUNT = {
      id: accountcode
    };
    //return this.http.get<OUTTYPE>(newurl+accountcode);
    return this.http.post<OUTTYPE>(newurl, account);
  }

  patchForm(registerform: FormGroup, formdata: OUTTYPE) {
    // debugger;
    if (formdata.out_supplier4_name) {
      (<FormArray>registerform.get('businessRefArray')).push(
        this.buildstrucBusinessRefItem()
      );
    }

    if (formdata.out_supplier3_name) {
      (<FormArray>registerform.get('businessRefArray')).push(
        this.buildstrucBusinessRefItem()
      );
    }

    if (formdata.out_supplier2_name) {
      (<FormArray>registerform.get('businessRefArray')).push(
        this.buildstrucBusinessRefItem()
      );
    }
    //console.log('formdata.out_mailing_email : ',formdata.out_org_type);
    registerform.patchValue({
      businessGroup: this.buildBusinessGroup(formdata),
      // deliverMethodArray: this.buildDeliverItems(formdata), //carefor, before here is a array, so need to return array here,
      businesscontacts: this.buildBusinessContacts(formdata),
      ownerinfoArray: this.buildOwnerInfo(formdata),
      businessRefArray: this.buildBusinessRef(formdata),
      marketinfo: this.buildMarketInfo(formdata),
      financialGroup: this.buildFinancialGroup(formdata),
      privacyGroup: {
        in_read_and_understood:
          formdata.out_read_and_understood == 'Y' ? true : false,
        // in_mailing_list: formdata.out_mailing_list == "Y" ? true : false,
        in_mailing_list_no: formdata.out_mailing_list == 'Y' ? false : true,
        in_mailing_list_yes: formdata.out_mailing_list == 'Y' ? true : false,
        in_mailing_email: formdata.out_mailing_email
      },
      declarationGroup: this.buildDeclarationGroup(formdata),
      guaranteeGroup: this.buildGuaranteeGroup(formdata)
    });

    if (!formdata.out_mailing_list) {
      registerform.get('privacyGroup.in_mailing_email').clearValidators();
      registerform
        .get('privacyGroup.in_mailing_email')
        .updateValueAndValidity();
    }

    // debugger;
    if (formdata.out_director2_name)
      (<FormArray>registerform.get('ownerinfoArray')).push(
        this.pushOwnerInfoDirector2(formdata)
      );
    if (formdata.out_director3_name)
      (<FormArray>registerform.get('ownerinfoArray')).push(
        this.pushOwnerInfoDirector2(formdata)
      );
  }

  buildBusinessContacts(formdata?: OUTTYPE) {
    return {
      in_manager_name: formdata.out_manager_name,
      in_manager_email: formdata.out_manager_email,

      in_manager_phonecode: (
        (formdata.out_manager_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_manager_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),

      in_manager_phone: formdata.out_manager_phone
        .trim()
        .substr(formdata.out_manager_phone.trim().split('sb')[0].length + 2)
        .trim(),

      in_so_manager_name: formdata.out_so_manager_name,
      in_so_manager_email: formdata.out_so_manager_email,

      in_so_manager_phonecode: (
        (formdata.out_so_manager_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_so_manager_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),

      in_so_manager_phone: formdata.out_so_manager_phone
        .trim()
        .substr(formdata.out_so_manager_phone.trim().split('sb')[0].length + 2)
        .trim(),

      in_po_manager_name: formdata.out_po_manager_name,
      in_po_manager_email: formdata.out_po_manager_email,

      in_po_manager_phonecode: (
        (formdata.out_po_manager_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_po_manager_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),

      in_po_manager_phone: formdata.out_po_manager_phone
        .trim()
        .substr(formdata.out_po_manager_phone.trim().split('sb')[0].length + 2)
        .trim(),

      in_ap_manager_name: formdata.out_ap_manager_name,
      in_ap_manager_email: formdata.out_ap_manager_email,
      in_ap_manager_phonecode: (
        (formdata.out_ap_manager_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_ap_manager_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),

      in_ap_manager_phone: formdata.out_ap_manager_phone
        .trim()
        .substr(formdata.out_ap_manager_phone.trim().split('sb')[0].length + 2)
        .trim(),

      in_3p_manager_name: [''],
      in_3p_manager_email: [''],
      in_3p_manager_phone: ['']
    };
  }
  //TODO market
  buildMarketInfo(formdata?: OUTTYPE) {
    //console.log("----->", formdata.out_focus_size, formdata.out_markets);

    let focusSize;

    if (formdata.out_focus_size == '<250') {
      focusSize = '250';
    }

    if (formdata.out_focus_size == '250-2000') {
      focusSize = '2000';
    }

    if (formdata.out_focus_size == '2001') {
      focusSize = '2000+';
    }

    let anunuity;
    if (formdata.out_percent_annuity_based == '<25') {
      anunuity = '25%';
    }

    if (formdata.out_percent_annuity_based == '25-50') {
      anunuity = '50%';
    }

    if (formdata.out_percent_annuity_based == '51') {
      anunuity = '50%+';
    }
    // debugger;
    return {
      in_other_product_desc: formdata.out_other_product_desc,
      in_other_market_desc:  formdata.out_other_market_desc,
      in_focus_size: focusSize,
      in_percent_annuity_based: anunuity,
      products: {
        in_principal_products_OEM:
          formdata.out_principal_products.indexOf('OEM') == -1 ? false : true,
        in_principal_products_PC:
          formdata.out_principal_products.indexOf('PC') == -1 ? false : true,
        in_principal_products_Peripherals:
          formdata.out_principal_products.indexOf('PERIPH') == -1
            ? false
            : true,
        in_principal_products_Consumables:
          formdata.out_principal_products.indexOf('CONSUM') == -1
            ? false
            : true,
        in_principal_products_Networking:
          formdata.out_principal_products.indexOf('NET') == -1 ? false : true,
        in_principal_products_Infrastructure:
          formdata.out_principal_products.indexOf('INFRA') == -1 ? false : true,
        in_principal_products_Telecommunications:
          formdata.out_principal_products.indexOf('TELE') == -1 ? false : true,
        in_principal_products_Software:
          formdata.out_principal_products.indexOf('SOFT') == -1 ? false : true,
        in_principal_products_Cloud:
          formdata.out_principal_products.indexOf('CLOUD') == -1 ? false : true,
        in_principal_products_Solutions:
          formdata.out_principal_products.indexOf('SOL') == -1 ? false : true,
        in_principal_products_Services:
          formdata.out_principal_products.indexOf('SERV') == -1 ? false : true,
        in_principal_products_Other:
          formdata.out_principal_products.indexOf('OTH') == -1 ? false : true
      },
      markets: {
        in_markets_CORP:
          formdata.out_markets.indexOf('CORP') == -1 ? false : true,
        in_markets_SME:
          formdata.out_markets.indexOf('SME') == -1 ? false : true,
        in_markets_CONS:
          formdata.out_markets.indexOf('CONS') == -1 ? false : true,
        in_markets_OEM:
          formdata.out_markets.indexOf('OEM') == -1 ? false : true,
        in_markets_GOV:
          formdata.out_markets.indexOf('GOV') == -1 ? false : true,
        in_markets_EDU:
          formdata.out_markets.indexOf('EDU') == -1 ? false : true,
        in_markets_WEB:
          formdata.out_markets.indexOf('WEB') == -1 ? false : true,
        in_markets_FIN:
          formdata.out_markets.indexOf('FIN') == -1 ? false : true,
        in_markets_TELE:
          formdata.out_markets.indexOf('TELE') == -1 ? false : true,
        in_markets_OTH: formdata.out_markets.indexOf('OTH') == -1 ? false : true
      }
    };
  }

  //TODO: CONVERT DATE TO REQUIRED FORMATf
  buildBusinessGroup(formdata?: OUTTYPE) {
    //console.log("before generate : ", formdata);
    return {
      //left
      in_org_type: orgTypeToValue.get(formdata.out_org_type), //registeredCompany
      in_customer_name: formdata.out_customer_name,
      in_entity_name: formdata.out_entity_name,
      in_trust_name: formdata.out_trust_name, //trustName
      in_ABN: formdata.out_ABN, //ABN
      in_ACN: formdata.out_ACN, //ACN

      in_RequestLimitCredit: formdata.out_RequestLimitCredit,

      in_date_business_started: this.dateFormattransfer(
        formdata.out_date_business_started
      ), //dataBusinessStart
      in_date_business_purchased: this.dateFormattransfer(
        formdata.out_date_business_purchased
      ),
      // '2017-11-17',
      in_bank_contact: formdata.out_bank_account_name,
      in_bank_address1: formdata.out_bank_address1, //bankDetail
      in_bank_address2: formdata.out_bank_address2,
      in_bank_address3: formdata.out_bank_address3,
      in_swift_address: formdata.out_swift_address,
      in_bank_account_name: formdata.out_bank_account_name,
      in_bsb: formdata.out_bsb,
      in_account_number: formdata.out_account_number,
      //right
      //right
      //right
      //right
      in_incorporation_date: this.dateFormattransfer(
        formdata.out_incorporation_date
      ),
      in_incorporation_place: formdata.out_incorporation_place,
      in_estimated_monthly_purch: formdata.out_estimated_monthly_purch,
      in_company_address1: formdata.out_company_address1,
      in_company_address2: formdata.out_company_address2,

      in_company_address3: formdata.out_company_address3,
      in_company_postcode: formdata.out_company_postcode,
      in_company_country: formdata.out_company_country,
      in_company_suburb: formdata.out_company_suburb,
      in_company_street: formdata.out_company_street,

      // out_delivery_address2
      in_parent_company: formdata.out_parent_company,
      in_delivery_address1: formdata.out_delivery_address1,
      in_delivery_address2: formdata.out_delivery_address2,
      in_delivery_address3: formdata.out_delivery_address3,
      in_tenancy: tenancyTypeToValue.get(formdata.out_tenancy),
      in_time_at_address: formdata.out_time_at_address,
      in_email: formdata.out_email,
      in_phonecode: (
        (formdata.out_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),
      in_phone: formdata.out_phone
        .trim()
        .substr(formdata.out_phone.trim().split('sb')[0].length + 2)
        .trim(),
      in_fax: formdata.out_fax,

      in_delivery_street: formdata.out_delivery_street,
      in_delivery_suburb: formdata.out_delivery_suburb,
      in_delivery_country: formdata.out_delivery_country,
      in_delivery_postcode: formdata.out_delivery_postcode,


      in_company_website_url: formdata.out_company_website_url,
      in_required_credit: creditTypeTypeToValue.get(
        formdata.out_required_credit
      ),
      in_online_contact: formdata.out_online_contact,
      in_admin_email: formdata.out_admin_email,
      in_password: formdata.out_password,
      in_part_ship: formdata.out_part_ship == 'N' ? 'No Part Ship' : 'Part Ship'
    };
  }

  buildDeliverItems(formdata?: OUTTYPE) {
    return [
      {
        in_delivery_street: formdata.out_delivery_street,
        in_delivery_suburb: formdata.out_delivery_suburb,
        in_delivery_country: formdata.out_delivery_country,
        in_delivery_postcode: formdata.out_delivery_postcode
      }
    ];
  }

  //TODO: there need a logic checking how many formadata.director do they have
  buildOwnerInfo(formdata?: OUTTYPE) {
    return [
      {
        in_director1_name: formdata.out_director1_name,
        in_director1_dob: formdata.out_director1_dob,
        in_director1_phonecode: (
          (formdata.out_director1_phone
            .trim()
            .split('sb')[0]
            .trim().length > 1
            ? '+'
            : '') +
          formdata.out_director1_phone
            .trim()
            .split('sb')[0]
            .trim()
        ).trim(),
        in_director1_phone: formdata.out_director1_phone
          .trim()
          .substr(formdata.out_director1_phone.trim().split('sb')[0].length + 2)
          .trim(),
        in_director1_street: formdata.out_director1_street,
        in_director1_suburb: formdata.out_director1_suburb,
        in_director1_country: formdata.out_director1_country,
        in_director1_postcode: formdata.out_director1_postcode,
        in_director1_address1: formdata.out_director1_address1,
        in_director1_address2: formdata.out_director1_address2,
        in_director1_address3: formdata.out_director1_address3,
        in_director1_licence_no: formdata.out_director1_licence_no
      }
    ];
  }

  pushOwnerInfoDirector2(formdata?: OUTTYPE) {
    return this.fb.group({
      in_director1_name: formdata.out_director2_name,
      in_director1_dob: formdata.out_director2_dob,

      in_director1_phonecode: (
        (formdata.out_director2_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_director2_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),
      in_director1_phone: formdata.out_director2_phone
        .trim()
        .substr(formdata.out_director2_phone.trim().split('sb')[0].length + 2)
        .trim(),
      in_director1_street: formdata.out_director2_street,
      in_director1_suburb: formdata.out_director2_suburb,
      in_director1_country: formdata.out_director2_country,
      in_director1_postcode: formdata.out_director2_postcode,
      in_director1_address1: formdata.out_director2_address1,
      in_director1_address2: formdata.out_director2_address2,
      in_director1_address3: formdata.out_director2_address3,
      in_director1_licence_no: formdata.out_director2_licence_no
    });
  }
  pushOwnerInfoDirector3(formdata?: OUTTYPE) {
    return this.fb.group({
      in_director1_name: formdata.out_director3_name,
      in_director1_dob: formdata.out_director3_dob,
      in_director1_phonecode: (
        (formdata.out_director3_phone
          .trim()
          .split('sb')[0]
          .trim().length > 1
          ? '+'
          : '') +
        formdata.out_director3_phone
          .trim()
          .split('sb')[0]
          .trim()
      ).trim(),
      in_director1_phone: formdata.out_director3_phone
        .trim()
        .substr(formdata.out_director3_phone.trim().split('sb')[0].length + 2)
        .trim(),
      in_director1_street: formdata.out_director3_street,
      in_director1_suburb: formdata.out_director3_suburb,
      in_director1_country: formdata.out_director3_country,
      in_director1_postcode: formdata.out_director3_postcode,
      in_director1_address1: formdata.out_director3_address1,
      in_director1_address2: formdata.out_director3_address2,
      in_director1_address3: formdata.out_director3_address3,
      in_director1_licence_no: formdata.out_director3_licence_no
    });
  }
  //TODO: there need a logic checking how many formadata.director do they have
  buildBusinessRef(formadata?: OUTTYPE) {
    if (formadata.out_supplier4_name) {
      return [
        {
          in_supplier1_name: formadata.out_supplier4_name,
          in_supplier1_contact: formadata.out_supplier4_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier4_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier4_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier4_phone
            .trim()
            .substr(
              formadata.out_supplier4_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier4_email
        },
        {
          in_supplier1_name: formadata.out_supplier3_name,
          in_supplier1_contact: formadata.out_supplier3_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier3_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier3_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier3_phone
            .trim()
            .substr(
              formadata.out_supplier3_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier3_email
        },
        {
          in_supplier1_name: formadata.out_supplier1_name,
          in_supplier1_contact: formadata.out_supplier1_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier1_phone
            .trim()
            .substr(
              formadata.out_supplier1_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier1_email
        },
        {
          in_supplier1_name: formadata.out_supplier2_name,
          in_supplier1_contact: formadata.out_supplier2_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier2_phone
            .trim()
            .substr(
              formadata.out_supplier2_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier2_email
        }
      ];
    } else if (formadata.out_supplier3_name) {
      return [
        {
          in_supplier1_name: formadata.out_supplier3_name,
          in_supplier1_contact: formadata.out_supplier3_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier3_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier3_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier3_phone
            .trim()
            .substr(
              formadata.out_supplier3_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier3_email
        },
        {
          in_supplier1_name: formadata.out_supplier1_name,
          in_supplier1_contact: formadata.out_supplier1_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier1_phone
            .trim()
            .substr(
              formadata.out_supplier1_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier1_email
        },
        {
          in_supplier1_name: formadata.out_supplier2_name,
          in_supplier1_contact: formadata.out_supplier2_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier2_phone
            .trim()
            .substr(
              formadata.out_supplier2_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier2_email
        }
      ];
    } else if (formadata.out_supplier2_name) {
      return [
        {
          in_supplier1_name: formadata.out_supplier1_name,
          in_supplier1_contact: formadata.out_supplier1_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier1_phone
            .trim()
            .substr(
              formadata.out_supplier1_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier1_email
        },
        {
          in_supplier1_name: formadata.out_supplier2_name,
          in_supplier1_contact: formadata.out_supplier2_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier2_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier2_phone
            .trim()
            .substr(
              formadata.out_supplier2_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier2_email
        }
      ];
    } else {
      return [
        {
          in_supplier1_name: formadata.out_supplier1_name,
          in_supplier1_contact: formadata.out_supplier1_contact,
          in_supplier1_phonecode: (
            (formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim().length > 1
              ? '+'
              : '') +
            formadata.out_supplier1_phone
              .trim()
              .split('sb')[0]
              .trim()
          ).trim(),
          in_supplier1_phone: formadata.out_supplier1_phone
            .trim()
            .substr(
              formadata.out_supplier1_phone.trim().split('sb')[0].length + 2
            )
            .trim(),
          in_supplier1_email: formadata.out_supplier1_email
        }
      ];
    }
  }

  //TODO: 数据的显示, 在前端
  buildFinancialGroup(formdata?: OUTTYPE) {
    return {
      in_current_year_turnover: formdata.out_current_year_turnover,
      in_last_year_turnover: formdata.out_last_year_turnover,
      in_capital: formdata.out_capital,
      in_no_of_shares: formdata.out_no_of_shares,

      //right
      in_current_assets: formdata.out_current_assets,
      in_current_liabilities: formdata.out_current_liabilities,
      in_encumberance_charges: formdata.out_encumberance_charges,

      //radio box TODO NOT YET
      //in_bankrupcy
      in_bankrupcyYes: formdata.out_bankrupcy == 'Y' ? true : false,
      in_bankrupcyNo: formdata.out_bankrupcy != 'Y' ? true : false
    };
  }

  buildDeclarationGroup(formdata?: OUTTYPE) {
    return {
      in_declare_name: formdata.out_declare_name,
      in_declare_path: '',
      //formdata.out_declare_path
      in_declare_position: formdata.out_declare_position,
      in_declare_date: this.dateFormattransfer(formdata.out_declare_date)
    };
  }

  buildGuaranteeGroup(formdata?: OUTTYPE) {
    return {
      in_guarantor_name: formdata.out_guarantor_name,
      in_guarantor_address1: formdata.out_guarantor_address1,
      in_guarantor_address2: formdata.out_guarantor_address2,
      in_guarantor_address3: formdata.out_guarantor_address3,

      //left
      in_guarantee_cust_name: formdata.out_guarantee_cust_name,

      in_guarantor_street: formdata.out_guarantor_street,
      in_guarantor_suburb: formdata.out_guarantor_suburb,
      in_guarantor_postcode: formdata.out_guarantor_postcode,
      in_guarantor_country: formdata.out_guarantor_country,
      // in_guarantor_sig_path: formdata.out_guarantor_sig_path,

      in_guarantor_date: this.dateFormattransfer(formdata.out_guarantor_date),

      //right
      in_guarantor_abn: formdata.out_guarantor_abn,
      in_witness_name: formdata.out_witness_name,
      in_witness_address1: formdata.out_witness_address1,
      in_witness_address2: formdata.out_witness_address2,
      in_witness_address3: formdata.out_witness_address3,

      in_witness_street: formdata.out_witness_street,
      in_witness_suburb: formdata.out_witness_suburb,
      in_witness_country: formdata.out_witness_country,
      in_witness_postcode: formdata.out_witness_postcode,

      // in_witness_sig_path: formdata.out_guarantor_sig_path,
      in_witness_date: this.dateFormattransfer(formdata.out_witness_date)
    };
  }

  buildstrucBusinessRefItem() {
    return this.fb.group({
      in_supplier1_name: [
        '',
        [
          Validators.required,
          Validators.minLength(this.RULES.min_length),
          Validators.maxLength(this.RULES.in_supplier1_name)
        ]
      ],
      in_supplier1_contact: [
        '',
        [
          Validators.required,
          Validators.minLength(this.RULES.min_length),
          Validators.maxLength(this.RULES.in_supplier1_contact)
        ]
      ],
      in_supplier1_phonecode: [''],
      in_supplier1_phone: [
        '',
        [
          Validators.required,
          Validators.maxLength(this.RULES.in_supplier1_phone)
          // ,patternValidator(/04[\d]{8}/g)
        ]
      ],
      in_supplier1_email: [
        '',
        [
          Validators.required,
          Validators.maxLength(this.RULES.in_email),
          patternValidator(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ]
      ]
    });
  }

  dateFormattransfer(outDate: string): string {
    let out = outDate.split('-');

    let ret = out[2] + '-' + monthStore.get(out[1]) + '-' + out[0];
    return ret;
  }
}

export const monthStore: Map<string, string> = new Map<string, string>();
monthStore.set('SEP', '09');
monthStore.set('JAN', '01');
monthStore.set('FEB', '02');
monthStore.set('MAR', '03');
monthStore.set('APR', '04');
monthStore.set('MAY', '05');
monthStore.set('JUN', '06');
monthStore.set('JUL', '07');
monthStore.set('AUG', '08');
monthStore.set('OCT', '10');
monthStore.set('NOV', '11');
monthStore.set('DEC', '12');



// WEBPACK FOOTER //
// ./src/app/services/register/retrieve.service.ts